import script from "./aiHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./aiHeader.vue?vue&type=script&setup=true&lang=js"

import "./aiHeader.vue?vue&type=style&index=0&id=6412f74e&lang=scss"

const __exports__ = script;

export default __exports__